<template>
  <div :class="classList">
    <slot></slot>
  </div>
</template>

<script lang="ts">
  // TODO: Might be possible to import this from scss

  import mixins from '../../mixins';

  const justifyItems = [
    'center',
    'start',
    'end',
    'left',
    'right',
    'space-between',
    'space-around',
    'space-evenly',
  ];

  const alignItems = [
    'center',
    'start',
    'end',
    'stretch',
    'baseline',
  ];

  // const alignContent = [
  //   'center',
  //   'start',
  //   'end',
  //   'stretch',
  //   'space-between',
  //   'space-around',
  //   'space-evenly',
  // ];

  const justifyProps = {} as any;
  justifyItems.forEach((value) => {
    justifyProps[`justify-${value}`] = { default: false, type: Boolean };
  });

  const alignItemsProps = {} as any;
  alignItems.forEach((value) => {
    alignItemsProps[`align-${value}`] = { default: false, type: Boolean };
  });

  // const alignContentProps = {} as any;
  // alignContent.forEach((value) => {
  //   alignContentProps[`align-content-${value}`] = { default: false, type: Boolean };
  // });

  const breakpoints = [
    { name: 'xs', classPrefix: 'col-' },
    { name: 'sm', classPrefix: 'col-sm-' },
    { name: 'md', classPrefix: 'col-md-' },
    { name: 'lg', classPrefix: 'col-lg-' },
    { name: 'xl', classPrefix: 'col-xl-' },
  ];
  const sizeProps = {} as any;
  const sizeClasses = {} as any;
  for (let breakpointIndex = 0; breakpointIndex < breakpoints.length; breakpointIndex += 1) {
    for (let size = 1; size <= 12; size += 1) {
      const breakpoint = breakpoints[breakpointIndex];
      sizeProps[breakpoint.name + size] = { default: false, type: Boolean };
      sizeClasses[breakpoint.name + size] = breakpoint.classPrefix + size;
    }
  }

  export default mixins().extend({
    props: {
      grow: { type: Boolean, default: false },
      shrink: { type: Boolean, default: false },
      ...sizeProps,
      ...justifyProps,
      ...alignItemsProps,
      // ...alignContentProps,
    },
    computed: {
      classList() {
        let classes = {} as any;
        let hasSizeProp = false;
        Object.keys(sizeProps).forEach((prop) => {
          const className = sizeClasses[prop];
          classes[className] = (this as any)[prop];
          hasSizeProp = hasSizeProp || classes[className];
        });
        classes.grow = (this as any).grow;
        classes.shrink = (this as any).shrink;
        // Set default class if no prop set
        if (!hasSizeProp) {
          classes.col = true;
        }
        classes = {
          ...classes,
          ...this.getClassListFromValues(justifyProps),
          ...this.getClassListFromValues(alignItemsProps),
          // ...this.getClassListFromValues(alignContentProps),
        };
        return classes;
      },
    },
    methods: {
      getClassListFromValues(values: any) {
        return Object.keys(values).reduce((result, name) => {
          const parsedName = name.replace(/([-_][a-z])/ig, ($1) => {
            return $1.toUpperCase()
              .replace('-', '')
              .replace('_', '');
          });
          return { ...result, [name]: this.$props[parsedName] };
        }, {});
      },
    },
  });
</script>
